import React from "react";
import { useSeo } from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/components/CTASection";
import { PROCESS, IMG } from "@/data/content";

export default function Werkwijze() {
  useSeo({
    title: "Werkwijze | Imperium Group",
    description: "Zo werkt Imperium Group: van audit & strategie, multichannel setup en executie tot het schalen en optimaliseren van jouw marketing op ROI.",
    path: "/werkwijze",
  });

  return (
    <div data-testid="werkwijze-page">
      <PageHero
        overline="Werkwijze"
        title="Van audit tot schaalbare ROI"
        subtitle="Een gestructureerde aanpak die álle marketingkanalen laat samenwerken richting één doel: meetbaar resultaat."
        image={IMG.meeting}
      />

      <section className="pb-24">
        <div className="mx-auto max-w-5xl px-6 lg:px-10">
          <div className="space-y-5">
            {PROCESS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.06}>
                <div className="flex flex-col gap-5 rounded-2xl border border-white/10 bg-[#12151D] p-8 sm:flex-row sm:items-center" data-testid={`werkwijze-step-${i}`}>
                  <span className="font-display text-4xl font-extrabold flame-text sm:w-24">{s.n}</span>
                  <div>
                    <h2 className="font-display text-xl font-semibold text-white lg:text-2xl">{s.title}</h2>
                    <p className="mt-2 text-base leading-relaxed text-slate-400">{s.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
